export default function storageAvailable(type) {
    var storage, x = '__storage_test__';

    if (global.window === undefined) { return false; }

    storage = window[type];
    try {
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (
            e.code === 22 ||
            e.code === 1014 ||
            e.name === 'QuotaExceededError' ||
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            storage.length !== 0;
    }
}



// WEBPACK FOOTER //
// ./src/Utils/StorageAvailable.js